import React from 'react'
import { Container, Row, Col} from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { Link } from 'react-router-dom';

export default function RegisterLanding() {
    const { t } = useTranslation()

    return (
        <Container fluid>
            <Row>
                <Col xs={12} className='py-4'>
                    <div id="logotipo-auth" className='text-center text-md-start px-3 pb-5'><Link to="/login"><img src="/images/logotipo-skill.svg" alt="Logotipo skillconnectED" /></Link></div>
                    <Container className='p-0 py-5 p-md-5'>
                        <Row>
                            <Col className='px-5 text-center mb-4'>
                                <h1>{t('registerlanding.whoareyou')}</h1>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={10} md={8} lg={5} className='mx-auto my-3'>
                                <div className="d-grid gap-2">
                                    <Link to="/registercandidate" className='btn btn-primary'>
                                        {t('registerlanding.professor')}
                                    </Link>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={10} md={8} lg={5} className='mx-auto my-3'>
                                <div className="d-grid gap-2">
                                    <Link to="/registerschool" className='btn btn-primary btn-block'>
                                        {t('registerlanding.searchingprofessor')}
                                    </Link>
                                </div>
                            </Col>
                        </Row>
                        <Row className="text-center my-3">
                            <Col>
                                {t('signin.haveaccount')}, <Link to="/login" className='link'>{t('signin.comein')}</Link>
                            </Col>
                        </Row>
                    </Container>
                </Col>
            </Row>
        </Container>
    )
}
